import { Controller } from "@hotwired/stimulus"

// eslint-disable-next-line import/no-default-export
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    if (!this.dialogTarget.open) {
      this.dialogTarget.showModal()
    }
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
